import styled from '@emotion/styled';
import { NewsType, NewsTypes } from '../domain/types/NewsType';
import { NoResults } from '../../../../components/common/no-results/NoResults';
import {
	INewsItemEntry,
	INewsletterEntry,
	IPressReleaseEntry,
} from '../../../../contentful';
import { mapNewsletter, mapPressRelease } from '../domain/utils/mapNewsItems';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';
import { Css, Responsive } from '../../../../ui';
import NewsItemList from './NewsItemList';
import NewsSectionHomeCards from '../../section/ui/NewsSectionHomeCards';

interface INewsroomOverviewListProps {
	listData: (INewsItemEntry | INewsletterEntry | IPressReleaseEntry)[];
	type: NewsType;
}

export default function NewsroomOverviewList({
	listData,
	type,
}: INewsroomOverviewListProps) {
	if (listData.length < 1) {
		return <NoResults />;
	}
	switch (type) {
		case NewsTypes.News:
			return (
				<NewsArticlesListWrapper>
					<NewsSectionHomeCards newsItems={listData as INewsItemEntry[]} />
				</NewsArticlesListWrapper>
			);
		case NewsTypes.Newsletter:
			return (
				<NewsItemList
					items={(listData as INewsletterEntry[]).map(mapNewsletter)}
					route={PageRoutes.CorporateNewsroomNewsletters}
				/>
			);
		case NewsTypes.PressRelease:
			return (
				<NewsItemList
					items={(listData as IPressReleaseEntry[]).map(mapPressRelease)}
					route={PageRoutes.CorporateNewsroomPressReleases}
					displayDateAndTitleOnly
				/>
			);
		default:
			return <NoResults />;
	}
}

const NewsArticlesListWrapper = styled.div`
	ul {
		padding: 0 ${Css.pxToRem(32)};

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			padding: 0;
		}
	}
`;
